import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * POST `/crm/quotations`：建立 DRAFT（可帶主／子項目 lines[]）。
 * body 由 `buildQuotationCreateBody` 組；不送衍生金額。
 */
export async function createQuotation(body) {
  const { data: raw } = await request.post('/crm/quotations', keysToSnake(body));
  return parseVer4DetailResponse(raw);
}
